import { create } from 'zustand';

export type BizyPageType =
	| 'home'
	| '1on1'
	| '1on1_list'
	| 'goals'
	| 'recaps'
	| 'rewards'
	| 'team'
	| 'incentives'
	| 'advice'
	| 'profile_self'
	| 'profile_other'
	| 'profile_bot'
	| 'settings'
	| 'bookmarks'
	| 'admin';

export interface BizyPageContext {
	pageName: string;
	pageType: BizyPageType;
	pageData?: Record<string, string>;
}

interface BizyPageContextStore {
	context: BizyPageContext;
	setContext: (context: BizyPageContext) => void;
}

const defaultContext: BizyPageContext = {
	pageName: 'Home',
	pageType: 'home',
};

export const useBizyPageContextStore = create<BizyPageContextStore>((set) => ({
	context: defaultContext,
	setContext: (context) => set({ context }),
}));
